var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45312 12.1444C9.07312 15.3281 11.6775 17.9325 14.8669 19.5525L17.3419 17.0719C17.6512 16.7625 18.0956 16.6725 18.4838 16.7963C19.7437 17.2125 21.0994 17.4375 22.5 17.4375C23.1244 17.4375 23.625 17.9381 23.625 18.5625V22.5C23.625 23.1244 23.1244 23.625 22.5 23.625C11.9362 23.625 3.375 15.0638 3.375 4.5C3.375 3.87563 3.88125 3.375 4.5 3.375H8.4375C9.06187 3.375 9.5625 3.87563 9.5625 4.5C9.5625 5.90062 9.7875 7.25625 10.2037 8.51625C10.3275 8.90438 10.2375 9.34875 9.92812 9.65812L7.45312 12.1444Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.c7087f71bfc2489d8b177f5869f76534.svg";
export { ForwardRef as ReactComponent };